import React, { useState, useRef, useEffect } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { searchWithoutAccents } from '@/utils/helpers';

const SearchableSelect = ({ options, value, onChange, placeholder, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filtrar opções sem acentos
  // Se search está vazio, mostrar todas as opções
  const filteredOptions = search.trim() === '' 
    ? options 
    : options.filter(opt =>
        searchWithoutAccents(opt.label, search) ||
        (opt.subtitle && searchWithoutAccents(opt.subtitle, search))
      );

  // Pegar label do valor selecionado
  const selectedLabel = options.find(opt => opt.value === value)?.label || '';

  const handleSelect = (option) => {
    onChange(option.value);
    setSearch('');
    setIsOpen(false);
  };

  return (
    <div ref={wrapperRef} className="relative">
      {label && <label className="text-sm font-semibold text-slate-700 mb-2 block">{label}</label>}
      
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 z-10" />
        <Input
          value={isOpen ? search : selectedLabel}
          onChange={(e) => {
            setSearch(e.target.value);
            setIsOpen(true);
          }}
          onFocus={() => setIsOpen(true)}
          placeholder={placeholder}
          className="pl-9 cursor-pointer"
          autoComplete="off"
        />
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.length === 0 ? (
            <div className="p-3 text-sm text-slate-500 text-center">
              Nenhuma pessoa encontrada
            </div>
          ) : (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                className={`p-3 hover:bg-slate-100 cursor-pointer transition-colors ${
                  option.value === value ? 'bg-blue-50' : ''
                }`}
              >
                <div className="font-semibold text-slate-900">{option.label}</div>
                {option.subtitle && (
                  <div className="text-xs text-slate-600">{option.subtitle}</div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
